import React from "react";

const Featured = ({ className = "" }) => {
  return (
    <span className={`label-group bg-primaryblue text-white ${className}`.trim()}>
      Featured
    </span>
  );
};

export default Featured;
